var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileSnsApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4008_17504)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.9797 16.9257C26.2984 16.4905 26.7079 16.1297 27.1798 15.8683C27.6516 15.6069 28.1747 15.4511 28.7127 15.4117C28.7586 15.9122 28.7025 16.4168 28.5478 16.8949C28.3931 17.3731 28.143 17.8149 27.8127 18.1937C27.5206 18.6009 27.1291 18.9267 26.6756 19.1401C26.2222 19.3534 25.7217 19.4473 25.2217 19.4127C25.1689 18.9683 25.2091 18.5177 25.3396 18.0896C25.47 17.6615 25.688 17.2652 25.9797 16.9257Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.3673 20.4047C25.9553 20.4047 27.0473 19.5957 28.4673 19.5957C29.1373 19.5669 29.8032 19.712 30.4005 20.0169C30.9977 20.3218 31.5058 20.7762 31.8753 21.3357C31.2982 21.6706 30.8201 22.1524 30.4895 22.732C30.1589 23.3117 29.9877 23.9685 29.9933 24.6357C29.997 25.39 30.2207 26.1269 30.6371 26.7559C31.0534 27.3849 31.6444 27.8787 32.3373 28.1767C32.3373 28.1767 30.6983 32.7897 28.4853 32.7897C27.4683 32.7897 26.6783 32.1047 25.6073 32.1047C24.5153 32.1047 23.4323 32.8157 22.7263 32.8157C20.7053 32.8157 18.1513 28.4397 18.1513 24.9227C18.1513 21.4617 20.3133 19.6467 22.3403 19.6467C23.6593 19.6457 24.6793 20.4047 25.3673 20.4047Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4008_17504"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30.0001,
    height: 30.0001,
    fill: "white",
    transform: "translate(9.99998 9.99998)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileSnsApple);
export default __webpack_public_path__ + "static/media/mobile-sns-apple.5f6f318c2dd174d18f3cde520f0e3f3a.svg";
export { ForwardRef as ReactComponent };